import { createSlice } from '@reduxjs/toolkit'
import { mainState } from '../interface';
import { createUserAction, getShortPostsTopAction } from '../actions';

const initialState: mainState = {
  topPosts: [],
  scrollSection: null,
  scrollPadding: null,
  isLoading: false,
  successMessage: null,
  errorMessage: null,
  loadingRegister: false,
}

const mainSlice = createSlice({
  name: 'main',
  initialState,
  reducers: {
    setMainScroll: (state, { payload }) => {
      state.scrollSection = payload.section;
      state.scrollPadding = payload.padding;
    },
    clearMainScroll: (state) => {
      state.scrollSection = null;
      state.scrollPadding = null;
    },
    clearMainMessages: (state) => {
      state.successMessage = null;
      state.errorMessage = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getShortPostsTopAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getShortPostsTopAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.topPosts = [...payload];
      })
      .addCase(getShortPostsTopAction.rejected, (state) => {
        state.isLoading = false;
        state.successMessage = null;
        state.errorMessage = null;
        // state.errorMessage = 'Ошибка при получении статей';
      })

      .addCase(createUserAction.pending, (state) => {
        state.loadingRegister = true;
      })
      .addCase(createUserAction.fulfilled, (state) => {
        state.loadingRegister = false;
        state.errorMessage = null;
        state.successMessage = 'Спасибо за запись. В ближайшее время я свяжусь с вами';
      })
      .addCase(createUserAction.rejected, (state) => {
        state.loadingRegister = false;
        state.successMessage = null;
        state.errorMessage = 'Ошибка при записи на консультацию';
      })
  },
})

export const {
  reducer: mainReducer,
  actions: {setMainScroll, clearMainScroll, clearMainMessages},
} = mainSlice;